export default class accessControl {
    constructor() {
        return {
            scope: {
                permission: '@',
                role: '@',
                hideForRole: '@',
                forAccount: '@',
                remove: '@'
            },
            controller: [
                '$scope', '$element', '$attrs', '$window', '$rootScope', 'AccessHandler',
                (scope, element, attrs, $window, $rootScope, AccessHandler) => {

                var validate = function() {
                    var letThrough = false;

                    // Current user is a Ruler which means access to everything
                    if (AccessHandler.isRuler()) {
                        element.show();
                        return true;
                    }

                    if (! scope.role && ! scope.permission && ! scope.hideForRole && !scope.forAccount) {
                        element.show();
                        return true;
                    }

                    if (scope.hideForRole) {
                        letThrough = ! AccessHandler.hasRole(scope.hideForRole.split('|'));
                    }

                    if (scope.role) {
                        letThrough = AccessHandler.hasRole(scope.role.split('|'));
                    }

                    if (scope.permission) {
                        letThrough = AccessHandler.hasPermission(scope.permission);
                    }

                    if (scope.forAccount) {
                        letThrough = AccessHandler.isAccount(scope.forAccount.split('|'));
                    }

                    if (! letThrough) {
                        if (scope.remove) {
                            element.remove();
                        } else {
                            element.hide();
                        }
                    } else if (! $(element).is(':visible')) {
                        element.show();
                    }
                };

                validate();

                var roleListener = $rootScope.$on('user:roles:set', validate);
                var accountInitListener = $rootScope.$on('currentAccount:initialized', validate);
                scope.$on('$destroy', roleListener);
                scope.$on('$destroy', accountInitListener);
            }]
        }
    }
}
